export const shoppingCartActionTypes={
    SET_CART_ITEMS:"SET_CART_ITEMS",
    SET_IS_CART_OPEN:"SET_IS_CART_OPEN"
}

